import {OauthService} from './oauth.service';
import {Subject} from 'rxjs/Subject';
import {Injectable} from '@angular/core';
import {Search} from '../models/search/search.model';
import {App} from 'ionic-angular';
import {Observable} from 'rxjs/Observable';
import {Http, URLSearchParams} from '@angular/http';
import {ToolsService} from './tools.service';
import { CeInterface } from '../models/ce/ce.interface';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class WebSliderService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }

  getWebSliders(): any {
    const url = this.Routing.generate('api_get_websliders', {'_format': 'json'}, true);
    return this.http.get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }

  getWebSliderImage(webSliderId: string): any {
    const url = this.Routing.generate('api_get_webslider_image', {'_format': 'json', 'webSliderId': webSliderId}, true);
    return this.http.get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }

  getWebSlidersByUrlSiteWeb(urlSiteWeb: string): any {
    const params = new URLSearchParams();
    params.set('url', urlSiteWeb);

    const url = this.Routing.generate('api_get_webslider_with_url', {'_format': 'json'}, true);

    return this.http.get(`${url}`, {search: params, headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/webSlider.service.ts